interface OnboardingStepTagProps {
  /** 1-indexed current step number. */
  step: number;
  /** Total steps in the flow (default 4 for base onboarding). */
  total?: number;
  /** Optional short label appended after the step count (e.g. "Listo",
   *  "Falló"). Omit when the surrounding UI already conveys the current
   *  status (e.g. the auto-flow eyebrow) to avoid duplicating the state. */
  label?: string;
  /** Optional flow prefix, e.g. "Configuración DGI" → renders "Configuración DGI · Paso 01 de 03". */
  flow?: string;
}

/**
 * Mono uppercase step indicator at the top of the form column. Replaces a
 * progress bar with text that stays readable on small screens, as specified
 * in the onboarding handoff.
 */
export function OnboardingStepTag({
  step,
  total = 4,
  label,
  flow,
}: OnboardingStepTagProps): JSX.Element {
  const stepStr = String(step).padStart(2, "0");
  const totalStr = String(total).padStart(2, "0");
  return (
    <div className="fx-onb-step-tag">
      <span>
        {flow ? `${flow} · ` : ""}
        Paso {stepStr} de {totalStr}
        {label ? ` · ${label}` : ""}
      </span>
    </div>
  );
}
